// Centralized image exports for CasinoBet
// Loads all image assets from the `allTypeCard/` directory and exposes them by basename

// Webpack (react-scripts) specific dynamic import for assets
const allTypeCardContext = require.context("./allTypeCard", true, /\.(png|jpe?g|gif|webp|svg)$/i);
const cardsContext = require.context("./cards", true, /\.(png|jpe?g|gif|webp|svg)$/i);

const allTypeCard = {};
const cards = {};
allTypeCardContext.keys().forEach((relativePath) => {
  const fileNameWithExt = relativePath.replace(/^\.\//, "");
  const baseName = fileNameWithExt.split("/").pop().replace(/\.[^/.]+$/, "");
  allTypeCard[baseName.toUpperCase()] = allTypeCardContext(relativePath);
});

cardsContext.keys().forEach((relativePath) => {
  const fileNameWithExt = relativePath.replace(/^\.\//, "");
  const baseName = fileNameWithExt.split("/").pop().replace(/\.[^/.]+$/, "");
  cards[baseName.toUpperCase()] = cardsContext(relativePath);
});

export { allTypeCard, cards };
export default {
  allTypeCard,
  cards,
};


